var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { ShimLayer, } from '@volkswagen-onehub/components-core';
import { getShimColor } from './utils';
const shimBackgroundTypeMap = {
    ["OPAQUE" /* OPAQUE */]: 'opaque',
    ["TRANSPARENT" /* TRANSPARENT */]: 'transparent',
};
export const Shim = (props) => {
    const { onClick, backgroundType, layerType } = props, ownProps = __rest(props, ["onClick", "backgroundType", "layerType"]);
    const shimBackgroundType = backgroundType
        ? shimBackgroundTypeMap[backgroundType]
        : undefined;
    return (React.createElement(ShimLayer, Object.assign({}, ownProps /* Used to pass through the animation props */, { key: "shim", backgroundType: getShimColor(layerType, shimBackgroundType), onClick: onClick })));
};
//# sourceMappingURL=shim.js.map